import { motion } from "framer-motion";

const NUMBER = "393921806509"; // +39 392 180 6509
const MESSAGE = encodeURIComponent(
    "Ciao Francesco! Ho visto il tuo sito e vorrei parlarti di un progetto — mi puoi dare qualche info?"
);
const HREF = `https://wa.me/${NUMBER}?text=${MESSAGE}`;

export default function WhatsAppButton() {
    return (
        <motion.a
            href={HREF}
            target="_blank"
            rel="noreferrer"
            aria-label="Scrivi su WhatsApp a Francesco Ciotoli"
            initial={{ opacity: 0, scale: 0.6, y: 20 }}
            animate={{ opacity: 1, scale: 1, y: 0 }}
            transition={{ delay: 2.2, duration: 0.6, ease: [0.19, 1, 0.22, 1] }}
            whileHover={{ scale: 1.08 }}
            whileTap={{ scale: 0.95 }}
            className="fixed bottom-5 right-5 md:bottom-6 md:right-6 z-[65] group"
            data-testid="whatsapp-button"
        >
            <span className="absolute inset-0 rounded-full bg-[#25D366] opacity-30 animate-ping" aria-hidden />
            <span className="relative flex items-center gap-2 bg-[#25D366] hover:bg-[#1ea952] text-white px-3.5 md:px-5 py-3 md:py-3.5 rounded-full shadow-2xl shadow-black/40 transition-colors">
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 24 24"
                    className="w-5 h-5 md:w-6 md:h-6 fill-white flex-shrink-0"
                    aria-hidden
                >
                    <path d="M20.52 3.48A11.94 11.94 0 0 0 12.04 0C5.5 0 .17 5.33.17 11.87c0 2.09.55 4.13 1.6 5.93L0 24l6.35-1.66a11.86 11.86 0 0 0 5.69 1.45h.01c6.53 0 11.86-5.33 11.86-11.87 0-3.17-1.23-6.15-3.39-8.44Zm-8.48 18.28h-.01a9.86 9.86 0 0 1-5.02-1.38l-.36-.21-3.77.99 1.01-3.68-.24-.38a9.86 9.86 0 0 1-1.51-5.23c0-5.45 4.43-9.88 9.88-9.88 2.64 0 5.12 1.03 6.99 2.9a9.83 9.83 0 0 1 2.89 6.99c0 5.45-4.43 9.88-9.86 9.88Zm5.42-7.4c-.3-.15-1.77-.87-2.04-.97-.27-.1-.47-.15-.66.15-.2.3-.76.97-.94 1.17-.17.2-.34.22-.64.07-.3-.15-1.27-.47-2.42-1.5-.9-.8-1.5-1.79-1.67-2.09-.17-.3-.02-.46.13-.61.13-.13.3-.34.45-.51.15-.17.2-.3.3-.5.1-.2.05-.37-.02-.52-.07-.15-.66-1.6-.91-2.19-.24-.58-.48-.5-.66-.5l-.56-.01c-.2 0-.52.07-.79.37-.27.3-1.04 1.01-1.04 2.47 0 1.46 1.06 2.87 1.21 3.07.15.2 2.1 3.2 5.09 4.49.71.31 1.27.49 1.7.62.71.23 1.36.2 1.87.12.57-.08 1.77-.72 2.02-1.42.25-.7.25-1.29.17-1.42-.07-.13-.27-.2-.57-.35Z" />
                </svg>
                <span className="hidden sm:inline font-mono text-[11px] md:text-[12px] tracking-[0.1em] font-semibold whitespace-nowrap">
                    Scrivimi su WhatsApp
                </span>
            </span>
        </motion.a>
    );
}
